import { render, staticRenderFns } from "./IntegrationModal.vue?vue&type=template&id=06795ca4"
import script from "./IntegrationModal.vue?vue&type=script&lang=js"
export * from "./IntegrationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06795ca4')) {
      api.createRecord('06795ca4', component.options)
    } else {
      api.reload('06795ca4', component.options)
    }
    module.hot.accept("./IntegrationModal.vue?vue&type=template&id=06795ca4", function () {
      api.rerender('06795ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/integration-modal/IntegrationModal.vue"
export default component.exports